// Select.tsx
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SelectChangeEvent, SelectProps } from '@mui/material'
import { BaseSelect } from './BaseSelect'

type Props = {
  name: string
  options: { value: string | number | boolean; label: string; disabled?: boolean }[]
  onChange?: (e: SelectChangeEvent<unknown>) => void
  fullWidth?: boolean
} & Omit<SelectProps, 'name'>

/**
 * MUI Select with react hook form
 */
const Select: React.FC<Props> = ({ name, options, label, onChange, ...props }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <BaseSelect
          {...props}
          options={options}
          value={String(field.value)}
          label={label}
          onChange={e => {
            const selectedOption = options.find(opt => String(opt.value) === e.target.value)
            field.onChange(selectedOption?.value)
            onChange?.(e)
          }}
        />
      )}
    />
  )
}

Select.displayName = 'Select'

export default Select
